import * as React from "react";
import * as ReactDOM from "react-dom";
import { FC } from "react";
import { Control } from "ol/control";
import { Point } from "ol/geom";
import { config } from "../config";

export const Home: FC<{ this: Control }> = (props) => {
    const onClick = () => {
        const view = props.this.getMap().getView();
        // @ts-ignore
        if (!view || !view.viewportSize_) {
            return;
        }
        // @ts-ignore
        const resolutionX = config.default.extentSize[0] / view.viewportSize_[0];
        // @ts-ignore
        const resolutionY = config.default.extentSize[1] / view.viewportSize_[1];
        const zoom = view.getZoomForResolution(resolutionX > resolutionY ? resolutionX : resolutionY);

        view.fit(new Point(config.default.center), {
            maxZoom: zoom,
            duration: 1000
        });
    };

    return (
        <>
            <div className="home-button" onClick={onClick} title={"Sākuma skats"}>
                <span className="icon-geo-latvia" />
            </div>
        </>
    );
};

export class HomeButton extends Control {
    constructor() {
        const element = document.createElement("div");
        element.className = "timberflowform-map-button home-container ol-unselectable ol-control";
        super({
            element
        });
        ReactDOM.render(<Home this={this} />, element);
    }
}
